<template>
  <Transition name="auth-overlay-fade">
    <div
      v-if="isVisible"
      class="fixed inset-0 z-[10000] flex flex-col items-center justify-center bg-gray-900/80 backdrop-blur-md"
    >
      <div class="relative flex flex-col items-center px-4">
        <div class="mb-8 overflow-visible pt-4">
          <svg
            class="tb-ci-text-accent h-24 w-24 overflow-visible"
            viewBox="0 -22 100 122"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="shackle"
              :class="mode === 'login' ? 'shackle-unlock' : 'shackle-lock'"
              d="M 30 50 L 30 35 C 30 15 70 15 70 35 L 70 50"
              fill="none"
              stroke="currentColor"
              stroke-width="10"
              stroke-linecap="round"
            />
            <rect x="15" y="50" width="70" height="45" rx="12" fill="currentColor" />
            <circle cx="50" cy="65" r="6" fill="#111827" />
            <path d="M 46 68 L 54 68 L 52 82 L 48 82 Z" fill="#111827" />
          </svg>
        </div>

        <h2 class="mb-3 text-center text-2xl font-bold tracking-wide text-white sm:text-3xl">
          {{ mode === 'login' ? t('auth.overlay.loginTitle') : t('auth.overlay.logoutTitle') }}
        </h2>
        <p class="flex items-center gap-3 text-lg text-gray-300">
          <svg
            class="tb-ci-text-accent h-5 w-5 animate-spin"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          {{ mode === 'login' ? t('auth.overlay.loginMessage') : t('auth.overlay.logoutMessage') }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

withDefaults(
  defineProps<{
    isVisible: boolean
    mode?: 'login' | 'logout'
  }>(),
  { mode: 'logout' },
)

const { t } = useI18n()
</script>

<style scoped>
.auth-overlay-fade-enter-active,
.auth-overlay-fade-leave-active {
  transition: opacity 0.5s ease;
}

.auth-overlay-fade-enter-from,
.auth-overlay-fade-leave-to {
  opacity: 0;
}

.shackle {
  transform-origin: 70px 50px;
}

.shackle-lock {
  transform: translateY(-15px) rotate(20deg);
  animation: lock-animation 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
  animation-delay: 0.1s;
}

.shackle-unlock {
  transform: translateY(0) rotate(0deg);
  animation: unlock-animation 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) forwards;
  animation-delay: 0.1s;
}

@keyframes lock-animation {
  0% {
    transform: translateY(-15px) rotate(20deg);
  }
  40% {
    transform: translateY(-15px) rotate(0deg);
  }
  100% {
    transform: translateY(0) rotate(0deg);
  }
}

@keyframes unlock-animation {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  60% {
    transform: translateY(-15px) rotate(0deg);
  }
  100% {
    transform: translateY(-15px) rotate(20deg);
  }
}
</style>
